'use client';

import { ShopContext } from '@/stores/shop/context';
import { ShopState } from '@/stores/shop/store';
import { useContext } from 'react';
import { useStore } from 'zustand';

export default function useShop<T>(selector: (state: ShopState) => T): T {
  const store = useContext(ShopContext);

  if (!store) {
    throw new Error('Missing ShopContext.Provider in the tree');
  }

  return useStore(store, selector);
}
